import React, { Component } from "react";
import "./App.css";
import io from "socket.io-client";
import Roommessage from "./Room";
import Chat from "./Chat";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
var socket = io("http://home.algorithm-net.com:6539/"); //socket-serve

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#0091ea",
    },
    secondary: {
      main: "#304ffe",
    },
  },
});

class App extends Component {
  constructor(props) {
    super(props);
    //init state
    this.state = {
      room: false,
      room_name: "",
      inp_message: "",
      username: "",
      messages: [],
      save_data: true,
    };
  }
  onChange_inp_message = (e) => {
    //quando cambia il valore nell 'input cambia lo stato
    this.setState({
      inp_message: e.target.value,
    });
  };

  onChange_username = (e) => {
    //quando cambia il valore nell 'input cambia lo stato
    this.setState({
      username: e.target.value,
    });
  };
  onChange_room = (e) => {
    //quando cambia il valore nell 'input cambia lo stato
    this.setState({
      room_name: e.target.value,
    });
  };
  joinroom = () => {
    //imposta lo state room su true
    this.setState({
      room: true,
    });

    if (window.localStorage.getItem("username") === null) {
      let users_save = JSON.stringify({ body: this.state.username });
      window.localStorage.setItem("username", users_save);
    } else if (
      JSON.parse(window.localStorage.getItem("username")).body ===
      this.state.username
    ) {
      //pass
    } else {
      let users_save = JSON.stringify({ body: this.state.username });
      window.localStorage.setItem("username", users_save);
    }
    if (window.localStorage.getItem(this.state.room_name) === null) {
      //pass
    } else {
      let messages = JSON.parse(
        window.localStorage.getItem(this.state.room_name)
      );
      console.log(messages.messages);
      this.setState({
        messages: messages.messages,
      });
    }

    socket.emit("join", { room: this.state.room_name });
  };
  leaveroom = () => {
    this.setState({
      room: false,
    });
    window.localStorage.setItem(
      this.state.room_name,
      JSON.stringify({ messages: this.state.messages })
    );
    socket.emit("leave", { room: this.state.room_name });
    this.setState({
      room_name: "",
      messages: [],
      inp_message: "",
    });
  };
  addMessage = () => {
    //manda uil messaggio
    if (
      this.state.inp_message === "" ||
      this.state.inp_message === " " ||
      this.state.inp_message === "  "
    ) {
      //se è vuoto non far nulla
      //pass
    } else {
      //altrimenti:
      //aggiunge il messaggio allo stato
      this.setState({
        inp_message: "",
        messages: [
          ...this.state.messages,
          {
            sender: this.state.username,
            body: this.state.inp_message,
          },
        ],
      });
      //manda il messaggio al server
      socket.emit("send", {
        user_name: this.state.username,
        message: this.state.inp_message,
        room: this.state.room_name,
      });
    }
  };
  componentDidMount() {
    //questo codeice è eseguito al montaggio del componente
    if (window.localStorage.getItem("username") === null) {
      //pass
    } else {
      let users_save = JSON.parse(window.localStorage.getItem("username"));
      this.setState({
        username: users_save.body,
      });
    }
    socket.on("connect", () => {
      console.log("connect"); //se la connessione va a buon fine tritorna connetc
    });
    socket.on("response", (msg) => {
      //all'arrivo di un messaggio
      console.log("message");
      console.log(msg);
      if (msg.message === "" || msg.message === " " || msg.message === "  ") {
        //pass
      } else if (msg.user_name === this.state.username) {
        // altrimenti se è mnadato dall 'utente non far di nuovo nulla
        //pass
      } else {
        //altriemnti
        //salva nello stato il messaggio
        this.setState({
          messages: [
            ...this.state.messages,
            {
              sender: msg.user_name,
              body: msg.message,
            },
          ],
        });
      }
    });
  }
  render() {
    if (this.state.room === false) {
      //se la room è false ritorna l'input room
      return (
        <ThemeProvider theme={theme}>
          <div>
            <Roommessage
              onChange_room={this.onChange_room}
              username={this.state.username}
              onChange2={this.onChange_username}
              joinroom={this.joinroom}
              room_id={this.state.room_name}
            />
          </div>
        </ThemeProvider>
      );
    } else {
      //altrimenti ritorna la chat
      return (
        <ThemeProvider theme={theme}>
          <div>
            <Chat
              state={this.state}
              onChange1={this.onChange_inp_message}
              addMessage={this.addMessage}
              messages={this.state.messages}
              room_code={this.state.room_name}
              leaveroom={this.leaveroom}
              username={this.state.username}
            />
          </div>
        </ThemeProvider>
      );
    }
  }
}

export default App;
